import { render, staticRenderFns } from "./DiscCaseSubArt.vue?vue&type=template&id=10b04fb6&"
import script from "./DiscCaseSubArt.vue?vue&type=script&lang=js&"
export * from "./DiscCaseSubArt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
